import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

export const DIALOG_TYPE = 'WHATS_NEW';

export const showWhatsNewDialog = createAction(
  rootUiActions.createDialog.toString(),
  (pageData, dispatchShowReleaseNotesDialog) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
    allowNesting: true,
    props: ImmutableMap({
      pageData,
      dispatchShowReleaseNotesDialog,
    }),
  }),
);
